import { fetchUtils } from 'react-admin';
import type { MerchantsOfferSummariesResource } from '../../../Entities/MerchantsOfferSummary';
import create from '../../create';
import type { JsonApiResource } from '../../JsonApiTypes';
import type { AuthProvider } from '../../AuthProvider';

export interface ReportMerchantOfferSummaryCreateParams {
  regionIds?: number[];
  merchantIds?: number[];
  hasOffers?: boolean;
}
export interface ReportMerchantOfferSummaryCreateResult {
  data: MerchantsOfferSummariesResource[];
  prefetched: Record<string, JsonApiResource[]>;
}
export type ReportMerchantOfferSummaryCreate = (
  params: ReportMerchantOfferSummaryCreateParams,
) => Promise<ReportMerchantOfferSummaryCreateResult>;

export default function merchantOfferSummaryCreate(
  apiUrl: string,
  httpClient = fetchUtils.fetchJson,
  canAccess: typeof AuthProvider.canAccess = async () => true,
): ReportMerchantOfferSummaryCreate {
  const createRecord = create(apiUrl, httpClient);
  return async (params) => {
    const prefetch = [];

    if (await canAccess({ resource: 'merchants_offer_summaries', action: 'list' })) {
      prefetch.push('results');
    }
    if (await canAccess({ resource: 'regions', action: 'list' })) {
      prefetch.push('results.region');
    }
    if (await canAccess({ resource: 'merchants', action: 'list' })) {
      prefetch.push('results.merchant');
    }
    if (await canAccess({ resource: 'merchant_statuses', action: 'list' })) {
      prefetch.push('results.merchant.merchant_status');
    }

    const result = await createRecord('reports', {
      data: {
        attributes: {
          report_type_id: 4,
          ...(params.regionIds?.length ? { region_ids: params.regionIds } : {}),
          ...(params.merchantIds?.length ? { merchant_ids: params.merchantIds } : {}),
          ...(typeof params.hasOffers === 'boolean' ? { has_offers: params.hasOffers } : {}),
        },
      },
      meta: {
        prefetch,
      },
    });
    const prefetched = (result.meta?.prefetched ?? {}) as Record<string, JsonApiResource[]>;
    return {
      data: (prefetched.merchants_offer_summaries ?? []) as MerchantsOfferSummariesResource[],
      prefetched,
    };
  };
}
